"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSearchableControl = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ArrowIcon_1 = require("../../../ArrowIcon");
const common_1 = require("../../../common");
const constans_1 = require("../helpers/constans");
const InputBox_1 = require("../../helpers/InputBox");
const InputControl_1 = require("../../helpers/InputControl");
const helpers_1 = require("../../../helpers");
const Icon_1 = require("../../../Icon");
const icons_1 = require("../../../icons");
const StyledInputControl = (0, styled_components_1.default)(InputControl_1.InputControl) `
    padding: 0 ${helpers_1.SPACING_S};
`;
const StyledInputBox = (0, styled_components_1.default)(InputBox_1.InputBox) `
    min-width: ${constans_1.MIN_WIDTH_COMBOBOX};
`;
function createSearchableControl({ formatText = ({ text }) => text, controlRef } = {}) {
    return function SearchableControlRenderer(_a) {
        var { className, actions, control, error, placeholder, searchTerm, disabled, size, active, opened, focused, text, testId, onSearchTermChange, onClear, option, value, hasEnterKeyStopPropagation = true, style } = _a, rest = __rest(_a, ["className", "actions", "control", "error", "placeholder", "searchTerm", "disabled", "size", "active", "opened", "focused", "text", "testId", "onSearchTermChange", "onClear", "option", "value", "hasEnterKeyStopPropagation", "style"]);
        const [inputFocused, setInputFocused] = (0, react_1.useState)(false);
        const hasClear = (0, react_1.useMemo)(() => (Boolean(text) || searchTerm !== null) && inputFocused && opened, [inputFocused, opened, searchTerm, text]);
        const rootRef = (0, react_1.useRef)(null);
        const inputControlRef = controlRef || rootRef;
        const inputControlValue = (0, react_1.useMemo)(() => (searchTerm !== null ? searchTerm : formatText({ text, value, option })), [option, searchTerm, text, value]);
        (0, react_1.useEffect)(() => {
            if (!opened) {
                setInputFocused(false);
            }
        }, [opened]);
        const clearAction = (0, react_1.useMemo)(() => {
            return {
                icon: react_1.default.createElement(Icon_1.Icon, { src: react_1.default.createElement(icons_1.ClearIcon, { error: error, disabled: disabled }) }),
                testId: testId ? `${testId}-clear-action` : undefined,
                onClick: () => {
                    var _a;
                    onClear();
                    (_a = inputControlRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }
            };
        }, [disabled, error, inputControlRef, onClear, testId]);
        const toggleAction = (0, react_1.useMemo)(() => {
            return {
                icon: react_1.default.createElement(ArrowIcon_1.ArrowIcon, { direction: common_1.ARROW_DIRECTION.down }),
                active: opened,
                testId: testId ? `${testId}-open-dropdown-action` : undefined,
                onClick: () => {
                    opened ? actions.close() : actions.open();
                }
            };
        }, [actions, opened, testId]);
        const actionsList = (0, react_1.useMemo)(() => [hasClear && clearAction, toggleAction], [clearAction, hasClear, toggleAction]);
        const isActive = (0, react_1.useMemo)(() => opened || active, [active, opened]);
        const onInputBlurHandler = (0, react_1.useCallback)((e) => {
            var _a;
            e.stopPropagation();
            (_a = control.onBlur) === null || _a === void 0 ? void 0 : _a.call(control, e);
        }, [control]);
        const onInputFocusHandler = (0, react_1.useCallback)((e) => {
            var _a, _b;
            if (inputControlValue) {
                (_a = inputControlRef.current) === null || _a === void 0 ? void 0 : _a.setSelectionRange(0, inputControlValue.length, 'none');
            }
            e.stopPropagation();
            (_b = control.onFocus) === null || _b === void 0 ? void 0 : _b.call(control, e);
            setInputFocused(true);
        }, [control, inputControlRef, inputControlValue]);
        const onInputChangeHandler = (0, react_1.useCallback)((e) => {
            onSearchTermChange(e.target.value);
        }, [onSearchTermChange]);
        const onInputKeyDownHandler = (0, react_1.useCallback)((e) => {
            if (!['Enter', 'Escape'].includes(e.key)) {
                e.stopPropagation();
            }
            if (e.key === 'Tab') {
                setInputFocused(false);
            }
        }, []);
        return (react_1.default.createElement(StyledInputBox, Object.assign({}, rest, { ref: control.ref, style: control.style, "data-selector-id": testId, hasError: error, isDisabled: disabled, tabIndex: -1, size: size, rows: 1, actions: actionsList, isActive: isActive, isFocused: focused, hasSpacing: false, onBlur: control.onBlur, onFocus: control.onFocus, onClick: control.onClick, onMouseDown: control.onMouseDown, onMouseUp: control.onMouseUp, onMouseEnter: control.onMouseEnter, onMouseLeave: control.onMouseLeave, onKeyDown: control.onKeyDown, onKeyUp: control.onKeyUp, onKeyPress: control.onKeyPress, className: className }),
            react_1.default.createElement(StyledInputControl, { disabled: disabled, tabIndex: 0, ref: inputControlRef, placeholder: placeholder, value: inputControlValue, hasEnterKeyStopPropagation: hasEnterKeyStopPropagation, onBlur: onInputBlurHandler, onFocus: onInputFocusHandler, onChange: onInputChangeHandler, onKeyDown: onInputKeyDownHandler, maxLength: 1024 })));
    };
}
exports.createSearchableControl = createSearchableControl;
//# sourceMappingURL=searchableControlRenderer.js.map